import { legacyRoutes } from '@/constants/legacyRoutes';
import { generateParamsForExpenseReportUrls } from '@/pages/register/expenses/utils';

export const generateProjectExpenseSuccessRedirectUrl = (
  paramValues: {
    projectId: string | undefined;
    contractId: string | undefined;
    employeeUserId: string | undefined;
    paymentMethodId: string | undefined;
    date: string | undefined;
  },
  accessValues: {
    projectAccess: boolean;
    contractAccess: boolean;
    projectAllExpensesTabPageAccess: boolean;
  },
  goToProjectAllExpensesTab: boolean = false,
) => {
  if (!accessValues.projectAccess) {
    // if no access to project, redirect to expense overview
    return `${legacyRoutes.reports.personal.expenseOverviewReport}?${generateParamsForExpenseReportUrls(
      {
        employeeUserId: paramValues.employeeUserId,
        projectId: paramValues.projectId,
        paymentMethodId: paramValues.paymentMethodId,
        date: paramValues.date,
      },
    )?.toString()}`;
  }

  if (
    !accessValues.contractAccess &&
    paramValues.projectId &&
    accessValues.projectAllExpensesTabPageAccess
  ) {
    // when no access to contract but project, redirect to all expenses on project page
    return `${legacyRoutes.projectManagement.allExpenses(paramValues.projectId)}`;
  }

  const params = new URLSearchParams();
  if (
    accessValues.contractAccess &&
    paramValues.contractId &&
    paramValues.projectId &&
    !goToProjectAllExpensesTab
  ) {
    params.set('openExpenseTab', 'True');
    params.set('contractId', paramValues.contractId);

    return `${legacyRoutes.projectManagement.contracts(paramValues.projectId)}?${params.toString()}`;
  }

  if (
    goToProjectAllExpensesTab &&
    paramValues.projectId &&
    accessValues.projectAllExpensesTabPageAccess
  ) {
    return `${legacyRoutes.projectManagement.allExpenses(paramValues.projectId)}`;
  }

  return `${legacyRoutes.reports.personal.expenseOverviewReport}?${generateParamsForExpenseReportUrls(
    {
      employeeUserId: paramValues.employeeUserId,
      projectId: paramValues.projectId,
      paymentMethodId: paramValues.paymentMethodId,
      date: paramValues.date,
    },
  )?.toString()}`;
};
